import { useRecoilValue } from "recoil";
import { UserRole } from "@common/utils/graphql";
import { PageWithTitle } from "@common/components/PageLayout/PageWithTitle";
import { CardholderHomePage } from "./CardholderHomePage";
import { NonCardholderHomePage } from "./NonCardholderHomePage";
import { availableRoles } from "@common/state/roleState";

export const NonAdminHomePage = () => {
  const roles = useRecoilValue(availableRoles);
  const isCardholder = roles.includes(UserRole.Cardholder);

  return (
    <PageWithTitle title="Home">
      {isCardholder ? <CardholderHomePage /> : <NonCardholderHomePage />}
    </PageWithTitle>
  );
};
